import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(apiError(err, "Connexion impossible."));
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full rounded-xl border border-line bg-cream px-4 py-3 text-base text-ink placeholder:text-muted2 focus:outline-none focus:ring-2 focus:ring-forest/30 focus:border-forest transition";

  return (
    <div className="min-h-screen bg-cream grid place-items-center px-4" data-testid="admin-login-page">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <img src="/logo.png" alt="MARY SERVICES" className="h-10 w-auto mx-auto" data-testid="admin-login-logo" />
          <p className="mt-2 text-sm text-muted2">Espace administrateur</p>
        </div>
        <form onSubmit={submit} className="rounded-3xl bg-white border border-line p-7 space-y-4 shadow-sm" data-testid="admin-login-form">
          <div className="flex items-center gap-2 text-forest">
            <Lock className="h-4 w-4" />
            <h1 className="font-semibold text-sm">Connexion sécurisée</h1>
          </div>
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="E-mail"
            aria-label="E-mail"
            data-testid="admin-login-email"
            className={inputCls}
          />
          <input
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Mot de passe"
            aria-label="Mot de passe"
            data-testid="admin-login-password"
            className={inputCls}
          />
          {error && (
            <p className="text-sm text-red-700 bg-red-50 rounded-lg px-3 py-2" data-testid="admin-login-error">
              {error}
            </p>
          )}
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="w-full rounded-full bg-forest text-cream font-semibold py-3.5 transition-colors hover:bg-pine disabled:opacity-60 inline-flex items-center justify-center gap-2"
          >
            {loading && <Loader2 className="h-4 w-4 animate-spin" />}
            Se connecter
          </button>
        </form>
        <p className="text-center mt-6">
          <a href="/" className="text-sm text-muted2 hover:text-forest transition-colors" data-testid="admin-login-back">
            ← Retour au site
          </a>
        </p>
      </div>
    </div>
  );
}
